import * as React from "react";
import "./ModalBackdrop.component.css";
import { useState } from "react";
export function ModalBackdrop({ children, dark = false, doNotShake = false, containerOnly = false, allowBackgroundInteraction = false, stackLevel = "default" }) {
    const [isAnimating, setIsAnimating] = useState(false);
    const handleBackdropClick = () => {
        if (doNotShake) {
            return;
        }
        setIsAnimating(true);
        setTimeout(() => {
            setIsAnimating(false);
        }, 500);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `modal-backdrop ${dark ? "modal-backdrop-dark" : ""} ${containerOnly ? "modal-backdrop-absolute" : ""} ${allowBackgroundInteraction ? "modal-backdrop-click-through" : ""} ${stackLevel === "low" ? "modal-backdrop-low" : ""}`, onClick: handleBackdropClick }),
        React.createElement("div", { className: `modal-foreground ${isAnimating ? "shake" : ""} ${stackLevel === "low" ? "modal-foreground-low" : ""}` }, children)));
}
